import { useLocalStorage } from '@mantine/hooks';
import type { FormState, VideoData, StructuredDescription } from '../types';
import { DEFAULT_FORM_STATE, DEFAULT_VIDEO_DATA, DEFAULT_STRUCTURED_DESC } from '../utils';

interface FullSubmitState {
  formState: FormState;
  isTitleManualMode: boolean;
  videoData: VideoData;
  subjectValue: string | null;
  isManualMode: boolean;
  structuredDesc: StructuredDescription;
}

const DEFAULT_STATE: FullSubmitState = {
  formState: DEFAULT_FORM_STATE,
  isTitleManualMode: false,
  videoData: DEFAULT_VIDEO_DATA,
  subjectValue: null,
  isManualMode: false,
  structuredDesc: DEFAULT_STRUCTURED_DESC,
};

type SetVal<T> = T | ((prev: T) => T);

function resolveVal<T>(updater: SetVal<T>, prevVal: T): T {
  return typeof updater === 'function' ? (updater as (prev: T) => T)(prevVal) : updater;
}

export function useSubmitForm() {
  const [state, setState] = useLocalStorage<FullSubmitState>({
    key: 'submit:all_form_state',
    defaultValue: DEFAULT_STATE,
  });

  return {
    formState: state.formState,
    setFormState: (val: SetVal<FormState>) => setState(prev => ({
      ...prev,
      formState: resolveVal(val, prev.formState),
    })),
    isTitleManualMode: state.isTitleManualMode,
    setIsTitleManualMode: (val: SetVal<boolean>) => setState(prev => ({
      ...prev,
      isTitleManualMode: resolveVal(val, prev.isTitleManualMode),
    })),
    videoData: state.videoData,
    setVideoData: (val: SetVal<VideoData>) => setState(prev => ({
      ...prev,
      videoData: resolveVal(val, prev.videoData),
    })),
    subjectValue: state.subjectValue,
    setSubjectValue: (val: SetVal<string | null>) => setState(prev => ({
      ...prev,
      subjectValue: resolveVal(val, prev.subjectValue),
    })),
    isManualMode: state.isManualMode,
    setIsManualMode: (val: SetVal<boolean>) => setState(prev => ({
      ...prev,
      isManualMode: resolveVal(val, prev.isManualMode),
    })),
    structuredDesc: state.structuredDesc,
    setStructuredDesc: (val: SetVal<StructuredDescription>) => setState(prev => ({
      ...prev,
      structuredDesc: resolveVal(val, prev.structuredDesc),
    })),
  };
}
